import { ThemeEnum } from '../../../../Theme';

import { ButtonBGEnum, type ButtonBGType } from '../../types/_bg';

import { SiteSizeEnum, type SiteSizeType } from './_size';
import { SiteVariantEnum, type SiteVariantType } from './_variants';
import { SiteVariantColorEnum, type SiteVariantColorType } from './_variantsColors';

/**
 * Site Themes
 */

import buttonDefaultStateTheme from '../_default';

import buttonSiteCommonTheme from './_common';

import buttonSiteVariantClassesMap from './variants';
import buttonSiteVariantColorThemeMap from './colors';

export type ButtonSiteThemeArgs = {
  variant?: SiteVariantType;
  variantColor?: SiteVariantColorType;
  bg?: ButtonBGType<ThemeEnum.Site>;
  size?: SiteSizeType;
};

/**
 * Button Site Theme
 */

const buttonSiteTheme = ({
  variant = 'Primary',
  variantColor = 'Brand',
  bg = 'Light',
  size = 'Medium',
}: ButtonSiteThemeArgs) => {
  if (!SiteVariantEnum[variant]) return buttonDefaultStateTheme;

  const { buttonSiteClasses, buttonSiteSizeClassesMap } = buttonSiteCommonTheme;

  const { buttonSiteVariantColorClasses, buttonSiteVariantColorShadowClasses } = buttonSiteVariantColorThemeMap
    .get(SiteVariantColorEnum[variantColor])
    .get(ButtonBGEnum[bg])(SiteSizeEnum[size]);

  const buttonThemeVariantColorClasses = buttonSiteVariantColorClasses
    .map((variantColorClasses) => variantColorClasses.get(SiteVariantEnum[variant]))
    .reduce((acc, curr) => acc.concat(' ', curr));

  const buttonThemeVariantClasses = buttonSiteVariantClassesMap
    .get(SiteVariantEnum[variant])
    .map((variantStateClass) => variantStateClass.get(ButtonBGEnum[bg]))
    .reduce((acc, curr) => acc.concat(' ', curr))
    .concat(' ', buttonThemeVariantColorClasses)
    .concat(' ', buttonSiteVariantColorShadowClasses);

  const buttonThemeSizeClasses = buttonSiteSizeClassesMap.get(SiteSizeEnum[size]);

  const buttonThemeIconClasses = '[&:not(svg)]:bg-current';

  return {
    buttonThemeClasses: buttonSiteClasses,
    buttonThemeVariantClasses,
    buttonThemeSizeClasses,
    buttonThemeTextClasses: '',
    buttonThemeIconClasses,
    buttonThemeOnlyIconSizeClasses: '',
  };
};

export default buttonSiteTheme;
